import TemplateHeader from '../components/Template-header';
import TemplateBodyField from '../components/template-body-field';
import ButtonEditor from '../components/button-editor';
import CustomInputText from '../../../../components/common/CustomInputText';

const MarketingStandardTemplate = ({
  control,
  watch,
  setValue,
  file,
  setFile,
  previewFile,
  validateMediaSize,
  getFormErrorMessage,

  textAreaRef,

  SPAM_SUGGESTIONS,
  showSpamSuggestions,
  setShowSpamSuggestions,
  checkForSpam,

  messsageVariables,
  menuRef,

  showEmoji,
  setShowEmoji,
  handleEmojiClick,

  tempVariables,
  handleEditVariable,
  handleDeleteVariable,
  watchContent,

  templateButtons,
  setTempBtn,
  handleQuickReplyChange,
  handleButtonEdit,
  removeButton,
  addQuickReplyBtn,
  handleAddCTA,
  getButtonTypeCounts,
  setImagePreview,
  setVideoPreview,
  setDocumentPreview,
}) => {
  return (
    <>
      <TemplateHeader
        control={control}
        watch={watch}
        setValue={setValue}
        file={file}
        setFile={setFile}
        previewFile={previewFile}
        validateMediaSize={validateMediaSize}
        getFormErrorMessage={getFormErrorMessage}
        setImagePreview={setImagePreview}
        setVideoPreview={setVideoPreview}
        setDocumentPreview={setDocumentPreview}
      />

      <TemplateBodyField
        control={control}
        textAreaRef={textAreaRef}
        getFormErrorMessage={getFormErrorMessage}
        SPAM_SUGGESTIONS={SPAM_SUGGESTIONS}
        showSpamSuggestions={showSpamSuggestions}
        setShowSpamSuggestions={setShowSpamSuggestions}
        checkForSpam={checkForSpam}
        messsageVariables={messsageVariables}
        menuRef={menuRef}
        showEmoji={showEmoji}
        setShowEmoji={setShowEmoji}
        handleEmojiClick={handleEmojiClick}
        tempVariables={tempVariables}
        handleEditVariable={handleEditVariable}
        handleDeleteVariable={handleDeleteVariable}
        watchContent={watchContent}
      />

      {/* Footer */}

      <div className="w-full">
        <CustomInputText
          name="footer"
          label="Footer"
          control={control}
          placeholer="Enter Footer Text"
          maxLength={60}
          required={false}
        />
      </div>

      {/* Buttons */}

      <ButtonEditor
        templateButtons={templateButtons}
        setTemplateButtons={setTempBtn}
        handleQuickReplyChange={handleQuickReplyChange}
        handleButtonEdit={handleButtonEdit}
        removeButton={removeButton}
        addQuickReplyBtn={addQuickReplyBtn}
        handleAddCTA={handleAddCTA}
        getButtonTypeCounts={getButtonTypeCounts}
        mode="MARKETING"
      />
    </>
  );
};

export default MarketingStandardTemplate;
